import { FC, useState } from "react"
import { UserPlus } from "lucide-react"
import { LOsTableWithImporter } from "../../loan-officers"
import { useIsAdmin, useUserRoles } from "../../../hooks"
import CreateBrandAdminModal from "../../brand-admin/create-brand-admin-modal"
import BrandAdminsList from "../../brand-admin/brand-admins-list"

interface Props {
  brandId?: string
}

const BrandDetailsLoanOfficers: FC<Props> = ({ brandId }) => {
  const isAdmin = useIsAdmin()
  const { isSuperAdmin, isBankAdmin, user } = useUserRoles()
  const [modalOpen, setModalOpen] = useState(false)

  const canCreate =
    isSuperAdmin || (isBankAdmin && String(user?.brand_id) === String(brandId))

  return (
    <div className="p-6 bg-white">
      {canCreate && (
        <div className="flex justify-end mb-4">
          <button
            type="button"
            className="inline-flex items-center rounded-md bg-primary-400 hover:bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-0"
            onClick={() => setModalOpen(true)}
          >
            <UserPlus size={16} className="mr-2" />
            Add Brand Admin
          </button>
        </div>
      )}
      {brandId && <BrandAdminsList brandId={brandId} canMasquerade={isAdmin} />}
      <LOsTableWithImporter
        searchParams={{ brand_id: brandId }}
        hasMasqueradeIcon={isAdmin}
      />
      {canCreate && brandId && (
        <CreateBrandAdminModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          brandId={brandId}
        />
      )}
    </div>
  )
}

export default BrandDetailsLoanOfficers
